import React from 'react';
import { compose, setPropTypes, pure } from 'recompose';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import DetailTextButton from '../atoms/DetailTextButton';
import EditTextButton from '../atoms/EditTextButton';
import ShopRelationTextButton from '../atoms/ShopRelationTextButton';

const styles = {
  firstTableCell: {
    borderRight: '1px solid #e0e0e0',
    padding: 10
  },
  leftIcon: {
    padding: '0px 5px'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired,
  groups: PropTypes.arrayOf(
    PropTypes.shape({
      groupId: PropTypes.number,
      groupName: PropTypes.string,
      zipCode: PropTypes.string,
      countryCode: PropTypes.string,
      prefectures: PropTypes.string,
      city: PropTypes.string,
      address: PropTypes.string,
      building: PropTypes.string,
      phone: PropTypes.string,
      email: PropTypes.string,
      createdAt: PropTypes.string
    })
  ).isRequired
};

const enhance = compose(
  pure,
  setPropTypes(propTypes)
);

const UserTableBody = enhance(
  ({
    groups,
    emptyRows,
    page,
    rowsPerPage,
    updateOpenDetailModal,
    updateOpenEditModal,
    updateOpenConfirm,
    setTargetRowId,
    order,
    orderBy
  }) => {
    let sortedResult;
    if (orderBy === 'streetAddress') {
      sortedResult = _.orderBy(
        groups,
        ['prefectures', 'city', 'address', 'building'],
        [order, order, order, order]
      );
    } else {
      sortedResult = _.orderBy(groups, orderBy, order);
    }
    const detailOpenAction = params => {
      updateOpenDetailModal(true);
      setTargetRowId(params.id);
    };
    const shopRelationAction = () => updateOpenConfirm(true);
    const editAction = () => {
      updateOpenEditModal(true);
    };
    return (
      <TableBody>
        {sortedResult
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map(group => {
            const params = {
              id: group.groupId
            };

            return (
              <TableRow key={group.groupId} hover>
                <TableCell>
                  <EditTextButton
                    id={group.groupId}
                    onClickAction={editAction}
                  />
                </TableCell>
                <TableCell>{group.groupName}</TableCell>
                <TableCell>
                  {`${group.prefectures} ${group.city} ${group.address} ${
                    group.building
                  }`}
                </TableCell>
                <TableCell>{group.phone}</TableCell>
                <TableCell>{group.email}</TableCell>
                <TableCell>
                  <DetailTextButton
                    params={params}
                    onClickAction={detailOpenAction}
                  />
                </TableCell>
                <TableCell>
                  <ShopRelationTextButton onClickAction={shopRelationAction} />
                </TableCell>
              </TableRow>
            );
          })}
        {emptyRows > 0 && (
          <TableRow style={{ height: 49 * emptyRows }}>
            <TableCell colSpan={7} />
          </TableRow>
        )}
      </TableBody>
    );
  }
);

export default withStyles(styles)(UserTableBody);
